import React from 'react';
import {AppBar, Button, Dialog, DialogContent, DialogTitle, Stack, Typography} from '@mui/material';

import {IconIllustration} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {HomeEnum, ProfileEnum} from 'presentation/constants';
import {useLocation, useNavigate} from 'react-router-dom';
import {HeaderContainer} from 'presentation/components/Modal/styles';
import {Footer} from './styles';
import {EmptyInfoModalEnum, EmptyInfoModalProps} from './types';

const {
	title,
	headerTitle,
	defaultDescription,
	primaryAction,
	secondaryAction,
	contactDescription,
	bankDescription,
	contactAndBankDescription,
	invalidEmail,
} = translations['pt-br'].privateFlow.refund.holderDataPage.modals.emptyInfosModal;

export const EmptyInfoModal = ({open, variant}: EmptyInfoModalProps) => {
	const navigate = useNavigate();
	const {pathname} = useLocation();
	const descriptions = {
		[EmptyInfoModalEnum.CONTACT]: contactDescription,
		[EmptyInfoModalEnum.BANK]: bankDescription,
		[EmptyInfoModalEnum.CONTACT_AND_BANK]: contactAndBankDescription,
		[EmptyInfoModalEnum.INVALID_EMAIL]: invalidEmail,
	};
	const {part1, part2, part3, part4, part5} = descriptions[variant];

	const handleGoToProfile = () => {
		navigate(ProfileEnum.PROFILE, {state: pathname});
	};

	const handleGoToHome = () => {
		navigate(HomeEnum.HOME_PAGE, {state: pathname});
	};

	return (
		<Dialog
			slotProps={{paper: {style: {maxWidth: 420, margin: 16, width: '100%'}}}}
			open={open}
			fullWidth>
			<AppBar elevation={0} position="relative">
				<HeaderContainer disableGutters>
					<DialogTitle sx={{p: 0}} variant="h6">
						{headerTitle}
					</DialogTitle>
				</HeaderContainer>
			</AppBar>
			<DialogContent sx={{p: 'initial'}}>
				<Stack alignItems="center" gap={2} padding={3}>
					<IconIllustration variant="info" />
					<Typography variant="h6" textAlign="center">
						{title}
					</Typography>
					<Stack>
						<Typography textAlign="center">
							{part1} <b>{part2}</b> {part3}
							{part4 && (
								<>
									<b>{part4}</b> {part5}
								</>
							)}
						</Typography>

						<Typography textAlign="center">{defaultDescription}</Typography>
					</Stack>
				</Stack>
			</DialogContent>
			<Footer>
				<Stack gap={1} sx={{width: '100%'}}>
					<Button fullWidth size="large" onClick={handleGoToProfile}>
						{primaryAction}
					</Button>
					<Button fullWidth size="large" variant="outlined" onClick={handleGoToHome}>
						{secondaryAction}
					</Button>
				</Stack>
			</Footer>
		</Dialog>
	);
};
